const PLACEHOLDER = /^__[A-Z_]+__$/;

export function getRuntimeConfig(): ScorecardRuntimeConfig {
  const c = window.__SCORECARD_CONFIG__;
  if (!c) {
    throw new Error("runtime config not loaded — is /runtime-config.js included before the bundle?");
  }
  for (const [k, v] of Object.entries(c)) {
    if (typeof v === "string" && PLACEHOLDER.test(v)) {
      throw new Error(`runtime config placeholder unsubstituted: ${k}`);
    }
  }
  return c;
}
